import classNames from 'classnames';

import { pathToURL } from '@/utils/urls';

import * as styles from './styles.module.scss';

export function getCountryCodeForLang(langISO: string): string {
    // Extract country from the ISO code (e.g., 'en-US' -> 'us', 'fr-FR' -> 'fr')
    const parts = langISO.split('-');
    if (parts.length > 1) {
        return parts[1].toLowerCase();
    }
    // Fallback to the language code itself
    return parts[0].toLowerCase();
}

interface FlagProps {
    countryCode: string;
    className?: string;
}

// Flag SVGs in public folder are sourced from npm package flag-icons
export default function Flag({ countryCode, className }: FlagProps) {
    if (!countryCode) return null;
    const code = getCountryCodeForLang(countryCode);
    return <img src={pathToURL(`flags/1x1/${code}.svg`)} alt={code} className={classNames(styles.flag, className)} />;
}
